import axios from "../../libs/httpClient";
import { host } from "../../libs/webRTC";

function normalizeFilterPayload(payload = {}) {
    const text = String(payload.substrings || "").trim();
    const fromSec = payload.fromSec === null || payload.fromSec === undefined ? "" : String(payload.fromSec);
    const toSec = payload.toSec === null || payload.toSec === undefined ? "" : String(payload.toSec);
    return {
        substrings: text,
        fromSec,
        toSec,
        // Остальные ограничения на сессии (группа, комната, даты и т.д.) уходят
        // в тот же запрос, чтобы поиск по тексту их не сбрасывал.
        filters: payload.filters || {},
        page: payload.page,
        limit: payload.limit
    };
}

export async function fetchSessionTableRows(payload = {}) {
    const normalized = normalizeFilterPayload(payload);
    const response = await axios.post(
        `${host}/studentData/filter/screencastText`,
        normalized,
        { withCredentials: true }
    );
    const { rows = [], total = 0, page = 1, limit = 0 } = response.data || {};
    return { rows, total, page, limit };
}

export async function fetchScreencastTextTimeline(token) {
    const response = await axios.get(`${host}/studentData/screencastText/${token}`, {
        withCredentials: true
    });
    return response.data;
}
